export default __webpack_public_path__ + "static/media/project_pending.87bf1e56.svg";